var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.28842V32.5274C1 33.5178 1.78415 34.3207 2.75143 34.3207H24.3055C25.2727 34.3207 26.0569 33.5178 26.0569 32.5274V5.28842H1Z",
    fill: "#F5F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.667 5.28842V31.1562C23.667 31.5524 23.3533 31.8735 22.9664 31.8735H1V32.5274C1 33.5178 1.78415 34.3207 2.75143 34.3207H24.3055C25.2727 34.3207 26.0569 33.5178 26.0569 32.5274V5.28842H23.667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3055 1H2.75143C1.78415 1 1 1.8029 1 2.7933V5.36016H26.0569V2.7933C26.0569 1.8029 25.2728 1 24.3055 1Z",
    fill: "#FFBA4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3056 1H23.667V5.36016H26.057V2.7933C26.057 1.8029 25.2729 1 24.3056 1Z",
    fill: "#FFBA4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36342 1H2.75143C1.78415 1 1 1.8029 1 2.7933V5.36016H7.36342V1Z",
    fill: "#FFBA4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99798 23.7203H4.96527C4.76344 23.7203 4.59985 23.5528 4.59985 23.3461V21.2648C4.59985 21.0582 4.76344 20.8907 4.96527 20.8907H6.99798C7.19981 20.8907 7.36339 21.0582 7.36339 21.2648V23.3461C7.36339 23.5528 7.19981 23.7203 6.99798 23.7203Z",
    fill: "#FFBA4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99798 29.6978H4.96527C4.76344 29.6978 4.59985 29.5303 4.59985 29.3236V27.2423C4.59985 27.0357 4.76344 26.8682 4.96527 26.8682H6.99798C7.19981 26.8682 7.36339 27.0357 7.36339 27.2423V29.3236C7.36339 29.5303 7.19981 29.6978 6.99798 29.6978Z",
    fill: "#FFBA4A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.622 24.964V22.9999C30.622 22.0095 29.8378 21.2066 28.8705 21.2066H20.8894C19.9221 21.2066 19.1379 22.0095 19.1379 22.9999V24.964H30.622Z",
    fill: "#F99864"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8705 36.6508H20.8894C19.9221 36.6508 19.1379 35.848 19.1379 34.8575V24.8922H30.622V34.8575C30.622 35.848 29.8378 36.6508 28.8705 36.6508Z",
    fill: "#DDFAFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5203 24.8922V33.7816C28.5203 34.1777 28.2066 34.4989 27.8197 34.4989H19.1379V34.8575C19.1379 35.848 19.9221 36.6508 20.8894 36.6508H28.8705C29.8378 36.6508 30.622 35.848 30.622 34.8575V24.8922H28.5203Z",
    fill: "#98EFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9398 17.3212C31.1822 15.0252 31.1822 11.3026 28.9398 9.00666C26.6974 6.71067 23.0618 6.71067 20.8195 9.00666C18.5771 11.3026 18.5771 15.0252 20.8195 17.3212C23.0618 19.6172 26.6974 19.6172 28.9398 17.3212Z",
    fill: "#FFEAB7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6188 12.965C30.5423 10.587 29.091 8.57151 27.0517 7.7197C27.6072 8.62481 27.9297 9.69505 27.9297 10.843C27.9297 14.09 25.3589 16.7223 22.1877 16.7223C21.404 16.7223 20.6573 16.561 19.9768 16.27C20.7476 17.5595 21.9998 18.5148 23.477 18.873C27.3238 19.8055 30.7415 16.7743 30.6188 12.965Z",
    fill: "#FFBA4A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5709 14.016C29.0307 11.9292 27.7513 9.8557 25.7131 9.38485C23.675 8.91399 21.6499 10.224 21.1901 12.3109C20.7302 14.3978 22.0097 16.4712 24.0478 16.9421C26.086 17.413 28.111 16.1029 28.5709 14.016Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9291 10.8714C27.9157 13.7545 25.8757 16.1454 23.1929 16.6307C23.7009 16.8904 24.2736 17.0374 24.8801 17.0374C26.9694 17.0374 28.6632 15.3031 28.6632 13.1639C28.6632 12.3058 28.3903 11.5133 27.9291 10.8714Z",
    fill: "#F5F8F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8705 21.2066H28.5203V22.5868C28.5203 22.983 28.2066 23.3042 27.8197 23.3042H19.1379V24.964H30.622V22.9999C30.622 22.0095 29.8378 21.2066 28.8705 21.2066Z",
    fill: "#F4874C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59985 10.1191L5.68273 11.4619L7.36339 9.37823",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8015 10.4201H9.7876",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0629 16.3622H9.7876",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4832 22.3055H9.7876",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7876 28.283H16.4832",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59985 16.0612L5.68273 17.404L7.36339 15.3204",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6265 27.8565H27.8435V33.6866",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9438 28.9906C22.0753 28.305 22.6654 27.7879 23.3735 27.7879C24.1782 27.7879 24.8305 28.4558 24.8305 29.2797C24.8305 30.1036 24.1782 30.7715 23.3735 30.7715",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3735 30.7715C24.1782 30.7715 24.8305 31.4394 24.8305 32.2633C24.8305 33.0872 24.1782 33.7551 23.3735 33.7551C22.6378 33.7551 22.0294 33.1968 21.9306 32.4714C21.9213 32.4034 21.9165 32.334 21.9165 32.2633",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8799 11.0812V13.1638H26.577",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5709 14.0161C29.0307 11.9292 27.7513 9.85573 25.7131 9.38488C23.675 8.91402 21.6499 10.2241 21.1901 12.3109C20.7302 14.3978 22.0097 16.4713 24.0478 16.9421C26.086 17.413 28.111 16.1029 28.5709 14.0161Z",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9398 17.3212C31.1822 15.0252 31.1822 11.3026 28.9398 9.00666C26.6974 6.71067 23.0618 6.71067 20.8195 9.00666C18.5771 11.3026 18.5771 15.0252 20.8195 17.3212C23.0618 19.6172 26.6974 19.6172 28.9398 17.3212Z",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1379 24.964H30.622",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99798 23.7203H4.96527C4.76344 23.7203 4.59985 23.5528 4.59985 23.3461V21.2648C4.59985 21.0582 4.76344 20.8907 4.96527 20.8907H6.99798C7.19981 20.8907 7.36339 21.0582 7.36339 21.2648V23.3461C7.36339 23.5528 7.19981 23.7203 6.99798 23.7203Z",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99798 29.6978H4.96527C4.76344 29.6978 4.59985 29.5303 4.59985 29.3236V27.2423C4.59985 27.0357 4.76344 26.8682 4.96527 26.8682H6.99798C7.19981 26.8682 7.36339 27.0357 7.36339 27.2423V29.3236C7.36339 29.5303 7.19981 29.6978 6.99798 29.6978Z",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0569 7.40869V2.7933C26.0569 1.8029 25.2727 1 24.3055 1H2.75143C1.78415 1 1 1.8029 1 2.7933V18.1001",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0569 21.2066V18.919",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.6107V32.5273C1 33.5177 1.78415 34.3206 2.75143 34.3206H19.1378",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36353 5.36016V1",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.825 5.36016H26.057V2.7933C26.057 1.8029 25.2728 1 24.3055 1H2.75143C1.78415 1 1 1.8029 1 2.7933V5.36016H18.373",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1379 29.7855V34.8575C19.1379 35.8479 19.9221 36.6508 20.8894 36.6508H28.8705C29.8378 36.6508 30.622 35.8479 30.622 34.8575V22.9999C30.622 22.0095 29.8378 21.2066 28.8705 21.2066H20.8894C19.9221 21.2066 19.1379 22.0095 19.1379 22.9999V27.2749",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c9f0e9e5b4a5673d76bbfa10c3a5cb1e.svg";
export { ForwardRef as ReactComponent };